module.exports = __webpack_public_path__ + "static/img/007.361a121b.png";